export function getReceptionStatusFieldClass(value: string | null | undefined): string {
  const normalized = (value ?? '').toString().trim().toUpperCase();
  return normalized === 'LLEGO' || normalized === 'LLEGÓ'
    ? 'reception-status-llego'
    : 'reception-status-no-llego';
}
